import { ComponentType, Fragment } from "react";
import styled from "styled-components/macro";
import { desaturate, lighten } from "polished";
import { WARNING_COLOR } from "../vars";

export default function Highlight({
  children: string,
  query = "",
  tag: Tag = Mark,
}: {
  children: string;
  query: string;
  tag?: ComponentType;
}) {
  if (!string) string = "";
  if (typeof string !== "string")
    throw new Error(
      "<Highlight> must have a single string child but was given: " + string
    );

  const regex = query.trim()
    ? new RegExp(
        query
          .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
          .split(" ")
          .map((s) => `(?:${s})?`)
          .join("\\W*\\b"),
        "gi"
      )
    : new RegExp("");

  let returned = [];
  let lastIndex = 0;
  let key = 0;

  string.replace(regex, (str, index) => {
    if (str.trim() !== "") {
      returned.push(
        <span key={++key}>{string.substring(lastIndex, index)}</span>
      );
      returned.push(<Tag key={++key}>{str}</Tag>);
      lastIndex = index + str.length;
    }

    return "";
  });

  returned.push(<Fragment key={++key}>{string.substring(lastIndex)}</Fragment>);

  return <Container>{returned}</Container>;
}

const Container = styled.span``;

const Mark = styled.span`
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 1;
  background: ${desaturate(0.2, lighten(0.3, WARNING_COLOR))};
`;
